import { actionTypes } from './types';

type Action<T> = import('./types').Action<T>;

export interface FormUpdateContactAction extends Action<typeof actionTypes.FORM_UPDATE_CONTACT> {
    type: typeof actionTypes.FORM_UPDATE_CONTACT;
    payload: unknown;
}

export interface FormUpdateAboutAction extends Action<typeof actionTypes.FORM_UPDATE_ABOUT> {
    type: typeof actionTypes.FORM_UPDATE_ABOUT;
    payload: unknown;
}

export interface FieldUpdateCreditLimitAction extends Action<typeof actionTypes.FIELD_UPDATE_CREDIT> {
    type: typeof actionTypes.FIELD_UPDATE_CREDIT;
    payload: {
        name: string;
        value: number;
    };
}

export interface VerifySoknadFieldAction extends Action<typeof actionTypes.VERIFY_SOKNAD_FIELD> {
    type: typeof actionTypes.VERIFY_SOKNAD_FIELD;
    payload: {
        name: string;
        value: string;
    };
}

export interface ChangeSoknadFieldAction extends Action<typeof actionTypes.CHANGE_SOKNAD_FIELD> {
    type: typeof actionTypes.CHANGE_SOKNAD_FIELD;
    payload: {
        name: string;
        value: string;
    };
}

export interface VerifyContactInfoAction extends Action<typeof actionTypes.VERIFY_CONTACT_INFO> {
    type: typeof actionTypes.VERIFY_CONTACT_INFO;
    amountEnabled: boolean;
}

export interface VerifySoknadSkjemaAction extends Action<typeof actionTypes.VERIFY_SOKNAD_SKJEMA> {
    type: typeof actionTypes.VERIFY_SOKNAD_SKJEMA;
}

export interface VerifyBestillingSkjemaAction extends Action<typeof actionTypes.VERIFY_BESTILLING_SKJEMA> {
    type: typeof actionTypes.VERIFY_BESTILLING_SKJEMA;
}

export type ApplicationActions =
    | FormUpdateAboutAction
    | FormUpdateContactAction
    | FieldUpdateCreditLimitAction
    | VerifySoknadFieldAction
    | ChangeSoknadFieldAction
    | VerifyContactInfoAction
    | VerifySoknadSkjemaAction
    | VerifyBestillingSkjemaAction;

// Fields
export const verifySoknadField = (name: string, value: string): VerifySoknadFieldAction => ({
    type: actionTypes.VERIFY_SOKNAD_FIELD,
    payload: { name, value },
});
export const changeSoknadField = (name: string, value: string): ChangeSoknadFieldAction => ({
    type: actionTypes.CHANGE_SOKNAD_FIELD,
    payload: { name, value },
});
export const verifyContactInfo = (amountEnabled: boolean): VerifyContactInfoAction => ({
    type: actionTypes.VERIFY_CONTACT_INFO,
    amountEnabled,
});
export const verifySoknadSkjema = (): VerifySoknadSkjemaAction => ({
    type: actionTypes.VERIFY_SOKNAD_SKJEMA,
});
export const verifyBestillingSkjema = (): VerifyBestillingSkjemaAction => ({
    type: actionTypes.VERIFY_BESTILLING_SKJEMA,
});
